import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { contactsBackend } from './contacts.backend';
import { contactsReducer } from './contacts.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('contacts', contactsReducer),
    BackendModule.forFeature('contacts', contactsBackend),
  ],
})
export class DatastoreContactsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contacts/contacts.module.ts